import type { DecorationFields } from "@innoclouds/ui";
import { useTranslation } from "i18next-vue";
import { computed } from "vue";
import { useProductNutritions } from "#/composables/useProductNutritions";
import { useCardStore } from "#/store/card";
import { useMainStore } from "#/store/main";
import { formatPrice, getLocaleName } from "#/utils/i18next";
import { hasNutritionValue } from "#/utils/nutritions";

export function useProductInsertFields() {
	const cardStore = useCardStore();
	const mainStore = useMainStore();
	const { t, i18next } = useTranslation();
	const { nutritions, weightLabel } = useProductNutritions();

	const macro = (key: string, value: number) => (hasNutritionValue(value) ? t(key, { amount: formatPrice(value) }) : null);

	return computed<DecorationFields>(() => ({
		name: getLocaleName(cardStore.stateCard.openCard, i18next.language),
		price: formatPrice(Number(cardStore.totalPrice_libCard ?? 0), mainStore.config_lib?.currency_symbol),
		weight: weightLabel.value,
		calories: macro("modal.product-description.energy-amount", nutritions.value.energy_amount),
		proteins: macro("modal.product-description.proteins-amount", nutritions.value.proteins_amount),
		fats: macro("modal.product-description.fat-amount", nutritions.value.fat_amount),
		carbs: macro("modal.product-description.carbohydrates-amount", nutritions.value.carbohydrates_amount),
	}));
}
